import { z } from 'zod/v4';
import { ITicket } from '../cms/ticket/ticket.interfaces';
import {
  IAdditionalEntryValue,
  NamedTariffProductDefinition,
  TariffProductDefinition,
  TariffProductGroup,
  TariffSelectionAttributeValue,
} from './product-group.interfaces';

export interface IValidation {
  isValid: boolean;
  messages: string[];
}

export interface IDirectTicketValidation {
  isValid: boolean;
  productExists: IValidation;
  productMatchesDefinition: IValidation;
  travelDate: IValidation;
  giftCodes: IValidation;
}

export const VALIDATION_SCHEMA: z.ZodType<IValidation> = z.object({
  isValid: z.boolean(),
  messages: z.array(z.string()),
});

export const DIRECT_TICKET_VALIDATION_SCHEMA: z.ZodType<IDirectTicketValidation> =
  z.object({
    isValid: z.boolean(),
    productExists: VALIDATION_SCHEMA,
    productMatchesDefinition: VALIDATION_SCHEMA,
    travelDate: VALIDATION_SCHEMA,
    giftCodes: VALIDATION_SCHEMA,
  });

export const DIRECT_TICKET_VALIDATIONS_SCHEMA: z.ZodType<
  IDirectTicketValidation[]
> = z.array(DIRECT_TICKET_VALIDATION_SCHEMA);

export interface ITicketOptions {
  tariffGroup: TariffProductGroup | undefined;
  selectionAttributes: TariffSelectionAttributeValue[];
  productSortOptions: TariffSelectionAttributeValue[];
  additionalEntries?: IAdditionalEntryValue[];
  product: TariffProductDefinition | undefined;
  amount: number;
  amountOfPeople: number;
  travelDate: Date | string | undefined | null;
}

export interface IOwnerData {
  id?: string | null;
  isForUser: boolean;
  salutation: string;
  firstName: string;
  lastName: string;
  dateOfBirth: Date | string | undefined;
  companions?: ICompanionData[];
}

export interface ICompanionData {
  id?: string | null;
  firstName: string;
  lastName: string;
}

export interface IPersonalData {
  salutation: string;
  firstName: string;
  lastName: string;
  dateOfBirth: Date | string | undefined;
  email: string;
  agreement: boolean;
}

export interface IConfiguredDirectTicket extends NamedTariffProductDefinition {
  tariffProductGroup: TariffProductGroup;
  ticket: ITicket | undefined;
  product: Partial<ITicketOptions>;
  owners?: Partial<IOwnerData>[];
  personalData: Partial<IPersonalData>;
  additionalEntries?: IAdditionalEntryValue[];
}

export interface IDirectTicketValidationRequest {
  products: IConfiguredDirectTicket[];
  serviceAreaId: number;
}
